<script>
  import { navigationStore } from "../../stores/navigationStore";
  import viewport from "../../actions/useViewport";

  export let header = "";
  export let text = "";
  export let footerText = "";
</script>

<section
  use:viewport
  on:enterViewport={() => navigationStore.changeActiveItem("features")}
  id="features"
>
  <h1>{header}</h1>
  <p>
    {text}
  </p>
  <h3>{footerText}</h3>

  <div class="features-img">
    <img src="./assets/images/features_img.webp" alt="Leadeboard" />
  </div>
</section>

<style>
  section {
    position: relative;
    width: 1008px;
    height: 381px;
    left: 194px;
    top: 267px;
  }

  h1 {
    position: absolute;
    white-space: nowrap;
    left: 0px;
    top: 110px;

    font-style: normal;
    font-weight: 800;
    font-size: 36px;
    line-height: 49px;
    text-align: center;

    /* Blue */
    color: #5666ed;
  }

  p {
    position: absolute;
    max-width: 418px;
    left: 1px;
    top: 110px;
    margin-top: 82px;

    font-family: Nunito Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 190%;

    /* or 30px */
    text-align: center;

    /* Gray */
    color: #6e6e6e;
  }

  h3 {
    position: absolute;
    width: 418px;

    left: 0px;
    top: 245px;

    margin-top: 26px;

    font-family: Nunito Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 190%;

    /* or 34px */
    text-align: center;

    /* Gray */
    color: #6e6e6e;
  }

  .features-img {
    position: absolute;
    width: 382px;
    height: 375px;
    right: 0;
    top: 0px;
  }

  @media (max-width: 1280px) {
    /* Phones and Tablets*/
    section {
      width: 100%;
      height: 720px;
      left: 0;

      padding: 0 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    h1 {
      position: static;
      width: 220px;
      margin-top: 120px;
      text-align: center;
      white-space: initial;
      font-size: 28px;
    }

    p {
      position: static;
      margin-top: 12px;
    }
    h3 {
      position: static;
      margin-top: 16px;
    }

    .features-img {
      position: static;
      width: 306px;
      margin-top: 32px;
    }
  }
</style>
